<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-6">
               <h1>Add New Withdrawal</h1>
            </div>
            <div class="col-xs-6 mandatoryDiv">
               <span class="mandatory_color">(*)</span> <span class="letter-right"> Marked are required field</span>
            </div>
         </div>
      </section>
      <section class="content">
         <div class="row">
            <form role="form" id="formID">
               <div class="col-sm-12">
                  <div class="alert alert-info" v-if="error_message">
                     {{error_message}}
                  </div>
               </div>
               <div class="col-sm-8">
                  <div class="box">
                     <div class="box-header">
                        <h3 class="box-title">
                           Withdraw Informations
                        </h3>
                     </div>
                     <div class="box-body form-box-body form-horizontal">
                        <div class="form-group">
                           <label class="col-md-4 control-label">Withdraw Account To <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <select title="" name="account_id" id="account_id" class="form-control input-sm select2" v-model="account_id" v-select="account_id">
                                 <option value="">-- Select --</option>
                                 <option :value="data.id" v-for="(data, index) in payment_method_arr" :key="data.id">{{data.bank_name}} [A/C: {{data.acc_name}} - {{data.acc_number}}]
                                 </option>
                              </select>
                              <label v-if="error_account_id" class="error" for="account_id">{{error_account_id}}</label>
                           </div>
                        </div>


                        <div class="form-group">
                           <label class="col-md-4 control-label">Available Balance <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <input name='available_balance' id='available_balance' class="form-control input-sm" value='' placeholder="Available balance" type="text" v-model="available_balance" readonly="">
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Withdraw Amount <span class="mandatory_horizontal">*</span></label>
                           <div class="col-md-8">
                              <input name='requested_amount' id='requested_amount' class="form-control input-sm" value='' placeholder="Withdraw Amount" type="text" v-model="requested_amount">
                              <label v-if="error_requested_amount" class="error" for="requested_amount">{{error_requested_amount}}</label>
                           </div>
                        </div>

                        <div class="form-group">
                           <label class="col-md-4 control-label">Description</label>
                           <div class="col-md-8">
                              <textarea name='description' id='description' class="form-control input-sm" v-model="description"></textarea>
                           </div>
                        </div>

                        <div class="form-group" v-if="edit">
                           <label class="col-md-4 control-label">Status</label>
                           <div class="col-md-8">
                              <select id='status' class="form-control input-sm" v-model="status">
                                 <option value="0">Requested</option>
                                 <option value="3">Cancel Now</option>
                              </select>
                           </div>
                        </div>

                     </div>
                  </div>

                  <div class="col-sm-12 btnRight">
                     <input type="submit" name="submit" value="Submit" class="btn btn-sm btn-submit btn-submit-big" @click="formSubmit"/>
                  </div>
               </div>
         
            </form>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
      name: "AddNewWithdrawal",
      data() {
         return {
            payment_method_arr : {},
            available_balance : '',
            requested_amount : '',
            description : '',
            account_id : '',
            status : 0,

            edit : false,
            editData : {},
            edit_id : '',
            
            error_message : '',
            error_account_id : false,
            error_requested_amount : false
         }
      },
      methods: {
         formSubmit(e) {
            e.preventDefault();
            var rootObject = this;

            var result = this.fromValidation();
            if (result) {
               setTimeout(function(){  
                  rootObject.error_account_id = false;
                  rootObject.error_requested_amount = false;
               }, 2000);
               return 0;
            }

            loader.show();
            const form = new FormData()

            form.append('requested_amount', this.requested_amount)
            form.append('description', this.description)
            form.append('account_id', this.account_id)

            if(this.edit){
               form.append('id', this.edit_id)
               form.append('status', this.status)
            }

            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }

            axios.post('affiliate/withdraws', form, config)
            .then(function (response) {
               //console.log(response);
               if(rootObject.edit){
                  rootObject.error_message =  "Withdraw Request Successfully Updated";
               }else{
                  rootObject.error_message =  "Withdraw Request Successfully Added";
               }
               
               loader.hide();
               setTimeout(function(){
                  if(!rootObject.edit){
                     rootObject.resetForm();
                  }
                  rootObject.error_message = '';
               }, 2000);
            })
            .catch(function (error) {
               let alertmessage = "";
               for (var prop in error.response.data) {
                   alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage);
               loader.hide();
               rootObject.com_errorHandel(error);
               rootObject.error_message =  alertmessage;
               setTimeout(function(){  
                  rootObject.error_message = '';
               }, 2000);
            });
         },

         fromValidation(reset = false){
            var has_error = false;
            this.error_account_id = false;
            this.error_requested_amount = false;

            if(!this.account_id){
               this.error_account_id = "This field is required";
               has_error = true;
            }

            if(!this.requested_amount){
               this.error_requested_amount = "This field is required";
               has_error = true;
            }

            if (has_error) {
               return true;
            }else{
               return false;
            }
         },

         resetForm(){
            var has_error = false;
            this.requested_amount = '';
            this.description = '';
            this.account_id = '';
         },

         loadEditData(){
            //console.log(this.editData);
            this.requested_amount = this.editData.requested_amount;
            this.description = this.editData.description;
            this.account_id = this.editData.account_id;
            this.status = this.editData.status;
            loader.hide();
         }
      },
      created(){
         this.com_user_type_access([1,2], true);
         loader.show();
         var rootObject = this;

         var encryptedData = rootObject.$store.getters.getUser;
         var decodedString  = rootObject.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         if(userData.user_level == 1) {
            this.$router.push('dashboard');
         }

         var queryStr = "";
         if(this.$route.params.id){
            this.edit_id = this.$route.params.id;
            this.edit = true;
            queryStr = "?id="+this.$route.params.id;
         }
         
         axios.get('affiliate/add-edit-withdraw-request'+queryStr).then(function (response) {
            rootObject.payment_method_arr = response.data.account_list;
            rootObject.available_balance = response.data.available_balance;
            //console.log(response);

            if(rootObject.edit){
               if(!response.data.editData){
                  rootObject.$router.push({ name: 'WithdrawLists' });
               }
               rootObject.editData = response.data.editData;
               rootObject.loadEditData();
            }else{
               loader.hide();
            }

         })
         .catch(function (error) {
            console.log(error)
            let alertmessage = "";
            for (var prop in error.response.data) {
               alertmessage += ' '+error.response.data[prop]
            }
            console.log(alertmessage);
            loader.hide();
            rootObject.com_errorHandel(error);
         });
      },

      mounted: function() {
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>